import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { formatTimestampIntoRelativeDate } from '@utils/formatTimestamp';
import { Application } from '@features/applications/types';

interface ApplicationActionTimeProps {
  applicationStatusLabel: string;
  application: Application;
}

function ApplicationActionTime({
  applicationStatusLabel,
  application,
}: ApplicationActionTimeProps) {
  return (
    <>
      <AccessTimeIcon
        fontSize="inherit"
        sx={{ verticalAlign: 'middle', marginRight: 1 }}
      />
      {applicationStatusLabel === 'terminated' &&
      application.application_actions.hired_action === 1 ? (
        <>
          Terminated{' '}
          {formatTimestampIntoRelativeDate(
            application.application_actions.action_date ?? '',
          )}
        </>
      ) : applicationStatusLabel === 'resigned' &&
        application.application_actions.hired_action === 2 ? (
        <>
          Resigned{' '}
          {formatTimestampIntoRelativeDate(
            application.application_actions.action_date ?? '',
          )}
        </>
      ) : (
        <>Applied {formatTimestampIntoRelativeDate(application.dt_timestamp)}</>
      )}
    </>
  );
}

export default ApplicationActionTime;
